module.exports = __webpack_public_path__ + "img/b8.0d662b67.png";